import logoSvg from "../assets/creabiz-logo.svg";

interface LogoProps {

  variant?: 'color' | 'white';

  className?: string;

}

export function Logo({ variant = 'color', className = '' }: LogoProps) {

  return (

    <img 

      src={logoSvg} 

      alt="Creabiz Logo" 

      className={className || "h-10 w-auto"}

      style={variant === 'white' ? { filter: 'brightness(0) invert(1)' } : {}}

    />

  );

}